import HttpClienteSeguroClass from '../../Servicios/HttpClienteSeguroClass';

// Obtiene el listado de requisitos de admisiones
// AdmissionId: Identificador de la admision
// AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const ListadoRequisitosAdmisiones = (filtro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post('/AdmisionesRequisitos/Listar/', filtro).then(response => {
            resolve(response);
        });
    });
};

// Obtiene el listado de requisitos de admisiones
// AdmissionId: Identificador de la admision
// AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const RequisitosAdmisionesMultiple = (filtro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post('/ProgramasRequsitosAdmision/Listado', filtro).then(response => {
            resolve(response);
        });
    });
};


// Se obtiene el detalle del requisito segun el identificador
// RequirementId: Identificador del requerimiento
// UserId: Identificador del usuario
// CompanyId: Identificador de la compa��a
// AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const ObtenerRequisitoAdmision = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/AdmisionesRequisitos/Obtener/", registro).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se aprueba el requisito de admisi�n
// RequirementId: Identificador del requerimiento
// Approved: Valor si fue aprobado o no
// UserId: Identificador del usuario
// CompanyId: Identificador de la compa��a
// AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const EstadoAprobacionRequisito = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.put("/AdmisionesRequisitos/Aprobacion/", registro).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se actualiza el estado de aprobaci�n del requisito de admisi�n
// RequirementId: Identificador del requerimiento
// Approved: Valor si fue aprobado o no
// ComplianceDate: Fecha de cumplimiento
// DeliveryDate: Fecha de entrega
// Comment: Comentarios adicionales
// UserId: Identificador del usuario
// CompanyId: Identificador de la compa��a
// AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const ActualizarDetalleRequisito = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.put("/AdmisionesRequisitos/ActualizarDetalle/", registro).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Se actualiza el estado de aprobaci�n del requisito de admisi�n
// AdmissionId: Identificador de la admisi�n
// UserId: Identificador del usuario
// CompanyId: Identificador de la compa��a
// AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const ValidarAprobacionRequisitos = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.put("/AdmisionesRequisitos/ValidarAprobaciones/", registro).then(response => {
            resolve(response);

        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

/**
 * 
 * @param {{ requirementId:string, accept:boolean, companyId:string,
 * userId:string,
 * peticionUsuario:{ userId:string, companyId:string, optionId:string, action:string } }} registro
 * @returns { Promise<{data:{}, status:number, error:{}, statusText:string}> }
 */
export const requisitoAdmisionAceptado = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/AdmisionesRequisitos/RequisitoAdmisionAceptado/", registro).then(response => {
            resolve(response);

        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

export default ListadoRequisitosAdmisiones